import { Avatar, Tooltip } from "@mui/material";
import { MouseEventHandler } from "react";
import { AvatarColors } from "../../themes/theme-factory";

export interface UserAvatarProps {
  userName: string;
  onClick: MouseEventHandler;
}

const GetBackgroundColor = (userName: string) => {
  return AvatarColors[
    userName
      .split("")
      .map((char) => char.charCodeAt(0))
      .reduce((sum, charCode) => sum + charCode, 0) % AvatarColors.length
  ];
};

const UserAvatar = ({ onClick, userName }: UserAvatarProps) => {
  return (
    <Tooltip title={userName}>
      {userName === "" ? (
        <Avatar
          sizes="small"
          sx={{
            backgroundColor: GetBackgroundColor(userName),
            fontSize: 12,
          }}
          onClick={onClick}
        />
      ) : (
        <Avatar
          sizes="small"
          sx={{
            backgroundColor: GetBackgroundColor(userName),
            fontSize: 12,
          }}
          onClick={onClick}
        >
          {userName
            .toUpperCase()
            .split(" ")
            .map((x) => x[0])}
        </Avatar>
      )}
    </Tooltip>
  );
};

export default UserAvatar;
